<template>
    <div id="app">  
    <full-page ref="fullpage" :options="options" id="fullpage">
    <div class="section">
        <div class="centered">
        <vue-typer :text='["Hello World", "My name is Tino"]' :pre-erase-delay='2500'></vue-typer>
        </div>    
        <ThreeParticles></ThreeParticles>
    </div>
    
  </full-page>  
    </div>
</template>

<script>
    import {VueTyper} from 'vue-typer'
    import ThreeParticles from './components/ThreeParticles.vue'

    export default {
        name: 'app',
        components: {
            VueTyper,
            ThreeParticles
        },
         data() { return {
             options: {
                menu: '#menu',
                anchors: ['page0', 'page1', 'page2', 'page3'],
                sectionsColor: ['#1b1b1b','#ffffff', '#a8ff3e', '#00bbf0']
      },
         }
         }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Source+Code+Pro:700&display=swap');

    * {
        box-sizing: border-box;
    }

    body {
        background: #1b1b1b;
        color: #ffffff;
        height: max-content;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        margin: 0;

    }

    .centered {
        position: static;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 100vw;
        height: 100vh;
        bottom: 10vh;
        left: 10vw;
    }

    .landmsg {
        width: 100%;
        height: 50%;
        text-align: center;
        margin: 120px auto;
    }

    .vue-typer {
        font-family: 'Source Code Pro', monospace;
        font-size: 90px;
        font-weight: 800;
        margin: 20vh 10vw;
        z-index: 99;
    }

    .vue-typer .custom.char.typed {
        color: #ffffff;
    }

    .vue-typer .custom.char.selected {
        color: #000000;
        background-color: #ffffff;
    }

    .vue-typer .custom.caret {
        background-color: #ffffff;
    }

    .vue-typer .custom.caret.typing {
        background-color: #ffffff;
    }

    .vue-typer .custom.caret.selecting {
        display: inline-block;
        background-color: #000;
    }

    @media only screen and (max-width: 756px) {
        .vue-typer {
            font-size: 60px;
            font-weight: 700;
        }
    }

</style>
